// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__7bqQc","skillsContainer":"Skills_skillsContainer__m1LES","skills":"Skills_skills__vPXZZ"};